import ContentCard from '../components/contentCard'

class ContentCards {
	components: ContentCard[] = []

	init(container: Document | HTMLElement = document) {
		container
			.querySelectorAll<HTMLElement>('.hg-content-card.is-collapsible, .hg-content-card-gradient.is-collapsible')
			.forEach((el) => {
				if (el.closest('.hg-dynamic-image-cards')) return
				const component = new ContentCard(el)
				component.init()
				this.components.push(component)
			})
	}

	update(container: Document | HTMLElement = document) {
		this.cleanup()
		this.init(container)
	}

	cleanup() {
		this.components.forEach((component) => component.cleanup())
		this.components = []
	}
}

export default new ContentCards()
